export const CONCRETE_DENSITY = 2400; // kg/m3

export function computePanelMetrics({ width, length, thickness, areaOverride, volumeOverride, massOverride }) {
  const w = parseFloat(width) || 0;
  const l = parseFloat(length) || 0;
  const t = parseFloat(thickness) || 0;
  const hasArea = areaOverride != null && areaOverride !== "";
  const hasVol = volumeOverride != null && volumeOverride !== "";
  const hasMass = massOverride != null && massOverride !== "";
  const area = hasArea ? parseFloat(areaOverride) : +(w * l).toFixed(3);
  const volume = hasVol ? parseFloat(volumeOverride) : +(area * t).toFixed(3);
  const mass = hasMass ? parseFloat(massOverride) : +(volume * CONCRETE_DENSITY).toFixed(1);
  return { area, volume, mass };
}

export function fmt(n, d = 2) {
  if (n == null || isNaN(n)) return "0";
  return Number(n).toLocaleString(undefined, { maximumFractionDigits: d });
}

export const LOAD_CAPACITY = 6.8; // m3

export const YARD_SCALE = 15; // px per meter (on-screen)

export function makeDefaultTables() {
  return [
    { id: "A", label: "TABLE A", w: 40, h: 9, x: 0, y: 0 },
    { id: "B", label: "TABLE B", w: 40, h: 4.5, x: 0, y: 11 },
    { id: "C", label: "TABLE C", w: 40, h: 9, x: 0, y: 17.5 },
  ];
}

// Ensures every table has an x/y position. If any are missing, seeds positions by
// flowing tables left-to-right into `cols` columns (preserves the old grid look).
export function layoutTablePositions(tables, cols = 1) {
  const tbls = tables || [];
  const hasPos = tbls.length > 0 && tbls.every((t) => Number.isFinite(t.x) && Number.isFinite(t.y));
  if (hasPos) return tbls;
  const n = Math.min(4, Math.max(1, cols || 1));
  const gap = 2; // metres between tables
  const out = [];
  let col = 0, x = 0, rowY = 0, rowMaxH = 0;
  tbls.forEach((t) => {
    out.push({ ...t, x, y: rowY });
    rowMaxH = Math.max(rowMaxH, t.h);
    col += 1;
    if (col >= n) {
      col = 0; x = 0; rowY += rowMaxH + gap; rowMaxH = 0;
    } else {
      x += t.w + gap;
    }
  });
  return out;
}

export function placementRect(pl, panel) {
  const hMeters = pl.rotated ? panel.width : panel.length;
  const vMeters = pl.rotated ? panel.length : panel.width;
  return { x: pl.x, y: pl.y, w: hMeters, h: vMeters };
}

// Returns a Set of placement ids that overlap another placement on the SAME table.
export function overlapIds(placements, panelsById) {
  const EPS = 0.02; // metres — ignore edge-touching / float noise
  const rects = placements
    .filter((pl) => panelsById[pl.panelId])
    .map((pl) => ({ id: pl.id, r: placementRect(pl, panelsById[pl.panelId]) }));
  const ids = new Set();
  for (let i = 0; i < rects.length; i++) {
    for (let j = i + 1; j < rects.length; j++) {
      const a = rects[i].r, b = rects[j].r;
      const ox = Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x);
      const oy = Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y);
      if (ox > EPS && oy > EPS) {
        ids.add(rects[i].id);
        ids.add(rects[j].id);
      }
    }
  }
  return ids;
}
